import { StateModel, StepStateType } from 'bff';
import { StepNumber } from 'types/stepper/stepper.type';

export type StepStructure = {
  step: StepNumber;
  state: StepStateType;
};

export const getStepStructure = (formState: StateModel): StepStructure[] => [
  {
    step: 1,
    state: formState.step1
  },
  {
    step: 2,
    state: formState.step2
  },
  {
    step: 3,
    state: formState.step3
  },
  {
    step: 4,
    state: formState.step4
  },
  {
    step: 5,
    state: formState.step5
  },
  {
    step: 6,
    state: formState.step6
  }
];

export const getAllowedSteps = (formState: StateModel): StepNumber => {
  const stepStructure = getStepStructure(formState).sort((a, b) => a.step - b.step);
  const firstDefault = stepStructure.find((step) => step.state === StepStateType.Default);
  const firstInvalid = stepStructure.find((step) => step.state === StepStateType.Invalid);

  let maxStep: StepNumber = 6;

  if (!firstDefault && !firstInvalid) maxStep = 6;

  if (!firstDefault && firstInvalid) maxStep = firstInvalid.step;

  if (firstDefault && !firstInvalid) maxStep = firstDefault.step;

  if (firstDefault && firstInvalid) {
    if (firstDefault.step < firstInvalid.step) maxStep = firstDefault.step;

    if (firstDefault.step > firstInvalid.step) maxStep = firstInvalid.step;
  }

  if (maxStep === 5) maxStep = 6; // Allow going to signing even when applications is not complete

  return maxStep;
};
